import { Component, Input } from '@angular/core';

import { Required } from '@app/shared/decorators/required';

import {
  IOpinCardButton,
  IOpinCardIcon,
  IOpinCardLink
} from './opin-card.model';

@Component({
  selector: 'app-opin-card',
  templateUrl: './opin-card.component.html',
  styleUrls: ['./opin-card.component.scss'],
  standalone: false
})
export class OpinCardComponent {
  @Input()
  @Required
  button: IOpinCardButton;

  @Input()
  @Required
  title: string;

  @Input()
  @Required
  icon: IOpinCardIcon;

  @Input()
  link?: IOpinCardLink;

  @Input()
  id?: string;
}
